module.exports = __webpack_public_path__ + "img/new-app.b77f14f7.svg";